import { Controller } from "@hotwired/stimulus"

// Handles the reservation edit form interactions
export default class extends Controller {
  static targets = ["dateWarning", "notesContainer", "submitButton"]
  
  connect() {
    this.originalStartDate = this.element.querySelector('input[name="reservation[start_date]"]').value
    this.originalEndDate = this.element.querySelector('input[name="reservation[end_date]"]').value
    this.checkDateChange()
  }
  
  // Check if dates have changed and show warning if they have
  checkDateChange() {
    const startDateField = this.element.querySelector('input[name="reservation[start_date]"]')
    const endDateField = this.element.querySelector('input[name="reservation[end_date]"]')
    
    const startDateChanged = startDateField.value !== this.originalStartDate
    const endDateChanged = endDateField.value !== this.originalEndDate
    
    if (startDateChanged || endDateChanged) {
      this.dateWarningTarget.classList.remove('hidden')
      
      // Make change notes required
      const notesField = this.element.querySelector('input[name="change_notes"]')
      if (notesField) {
        notesField.setAttribute('required', 'required')
        notesField.setAttribute('aria-required', 'true')
      }
    } else {
      this.dateWarningTarget.classList.add('hidden')
      
      // Make change notes optional
      const notesField = this.element.querySelector('input[name="change_notes"]')
      if (notesField) {
        notesField.removeAttribute('required')
        notesField.removeAttribute('aria-required')
      }
    }
  }
  
  // Handle form submission
  handleSubmit(event) {
    // If the form submission was successful, we don't need to do anything
    if (event.detail?.success) return
    
    // If there was an error, scroll to the top of the form to show error messages
    window.scrollTo({ top: 0, behavior: 'smooth' })
    
    // Highlight any fields with errors
    const errorFields = this.element.querySelectorAll('.field_with_errors input, .field_with_errors select, .field_with_errors textarea')
    errorFields.forEach(field => {
      field.classList.add('border-red-500', 'ring-red-500')
    })
  }
  
  // Validate the form before submission
  validateForm(event) {
    const startDateField = this.element.querySelector('input[name="reservation[start_date]"]')
    const endDateField = this.element.querySelector('input[name="reservation[end_date]"]')
    const notesField = this.element.querySelector('input[name="change_notes"]')
    
    const startDateChanged = startDateField.value !== this.originalStartDate
    const endDateChanged = endDateField.value !== this.originalEndDate
    
    // If dates have changed, ensure notes are provided
    if ((startDateChanged || endDateChanged) && (!notesField.value || notesField.value.trim() === '')) {
      event.preventDefault()
      alert('Please provide a reason for changing the reservation dates.')
      notesField.focus()
      return false
    }
    
    // Ensure end date is after start date
    if (new Date(endDateField.value) <= new Date(startDateField.value)) {
      event.preventDefault()
      alert('End date must be after start date.')
      endDateField.focus()
      return false
    }
    
    return true
  }
}
